import { Paper, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PanToolIcon from "@mui/icons-material/PanTool";

import React from "react";
const PermittedPopu = ({  }) => {
    const theme = useTheme();
    return (
        <>
            <Paper sx={{ backgroundColor: theme.palette.background.paper, boxShadow: 3, padding: '10px', overflowY: "auto", maxHeight: "90vh" }} >
                <Typography  style={{display:'flex',alignItems:'center', justifyContent: 'center' }}>
                 <h2>Not Permitted <PanToolIcon/> </h2>
                </Typography>
                <Typography mb={0} p={3} pt={1} lineHeight={1.8}>
                 You do not have the necessary permissions to access this account. Please contact your administrator or support team for further assistance.
                </Typography>
            </Paper>
        </>
    );
}

export default PermittedPopu;
